module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tAvez-vous des crédits en cours ?\n\t\t\t")]), _vm._v(" "), _c('custom-toggle', {
    attrs: {
      "value": _vm.isCredits
    },
    on: {
      "change": function($event) {
        _vm.isCredits = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.isCredits) ? _c('div', [_c('div', {
    staticClass: "form-elem-container ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tQuel est le pourcentage de votre taux d’endettement global selon vous ?\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-input"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.overallDebtPercentage),
      expression: "overallDebtPercentage"
    }],
    staticStyle: {
      "width": "150px",
      "border": "1px solid var(--input-grey)"
    },
    attrs: {
      "type": "text",
      "size": "10",
      "name": "overallDebtPercentage"
    },
    domProps: {
      "value": (_vm.overallDebtPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.overallDebtPercentage = $event.target.value
      }
    }
  }), _vm._v(" %\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-add-children ctn-toggle row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tQuels sont vos crédits en cours ?\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "select-btn-container"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.typeOfLoan,
      "selected": _vm.currentLoanType
    },
    on: {
      "change": function($event) {
        _vm.currentLoanType = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addLoan
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-childrens"
  }, _vm._l((_vm.loans), function(child, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-children"
    }, [_c('div', {
      staticClass: "type-children row"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(child.type) + " " + _vm._s(key + 1) + " "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.removeLoan(key)
        }
      }
    }, [_vm._v("supprimer")])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('capital restant' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'capital restant' + (key + 1)
      }
    }, [_vm._v("Capital restant dû")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.value),
        expression: "child.value"
      }],
      key: 'amount' + key,
      attrs: {
        "type": "text",
        "name": 'capital restant' + (key + 1)
      },
      domProps: {
        "value": (child.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": child.currency
      },
      on: {
        "change": function($event) {
          child.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('capital restant' + (key + 1))))])]), _vm._v(" "), _c('div', {
      staticClass: "form-elem-container row"
    }, [_c('div', {
      staticClass: "ctn-input ctn-label three",
      class: {
        error: _vm.errors.has('mensualité' + (key + 1))
      }
    }, [_c('label', {
      attrs: {
        "for": 'mensualité' + (key + 1)
      }
    }, [_vm._v("Mensualité")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (child.monthlyPayment),
        expression: "child.monthlyPayment"
      }],
      key: 'monthly' + key,
      attrs: {
        "type": "text",
        "name": 'mensualité' + (key + 1)
      },
      domProps: {
        "value": (child.monthlyPayment)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(child, "monthlyPayment", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('custom-select', {
      attrs: {
        "items": _vm.currencies,
        "selected": child.currency
      },
      on: {
        "change": function($event) {
          child.currency = $event
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.errors.first('mensualité' + (key + 1))))])])])
  }), 0)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f74102"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Credits.vue
// module id = 1135
// module chunks = 0